import React from 'react';

function PageBanner({ title, backgroundImage }) {
    return (
        <section className="relative h-[40vh] md:h-[50vh] overflow-hidden">
            <img 
                src={backgroundImage}
                alt={`${title} Banner`}
                className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary/50 to-primary/70 flex items-center justify-center">
                <div className="text-center px-4">
                    <h1 className="text-4xl md:text-5xl lg:text-7xl font-arial-rounded font-bold text-white animate-fadeIn mb-4 md:mb-6">
                        {title}
                    </h1>
                    <div className="w-24 md:w-32 h-1.5 bg-primary-yellow mx-auto animate-expandWidth mb-8"/>
                </div>
            </div>
        </section>
    );
}

export default PageBanner;
